/* @flow */

import ObjectDetailDrill from "../drill/ObjectDetailDrill";

import type { QueryMode } from "platopulse/meta/types/Visualization";

const ObjectMode: QueryMode = {
    name: "object",
    actions: [],
    drills: [ObjectDetailDrill]
};

export default ObjectMode;



// WEBPACK FOOTER //
// ./qb/components/modes/ObjectMode.jsx